import manufacturerPackage from './manufacturerPackage.json'
import manufacturerOrder from './manufacturerOrder.json'

const frManufacturer = {
    ...manufacturerPackage,
    ...manufacturerOrder
}

export default frManufacturer